<template>
    <v-dialog
        v-model="c.show"
        :max-width="this.orderconfirmation && this.orderconfirmation.length ? 500 : 360"
    >
        <v-sheet color="primary">
            <div class="headline align-start flex-column pa-2 primary primarytext--text">
                <div class="font-weight-bold fill-width">
                    <v-btn icon @click="c.show = false" class="float-right"><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </div>
            </div>

            <div class="mb-4 d-flex justify-center white--text">
                <v-icon x-large class="white--text">mdi-checkbox-marked-circle-outline</v-icon><span class="text-h4 ml-4">{{$translate('Done!')}}</span>
            </div>

            <div class="d-flex">
                <v-avatar size="60" class="mx-2">
                    <v-auto-img :src="$root.siteconfig.appbar.props.logo" />
                </v-avatar>
                <v-card class="ma-2">
                    <v-card-text>
                        <div><span class="font-weight-bold">{{thankYouText}}</span></div>
                    </v-card-text>
                </v-card>
            </div>

            <div class="d-flex" v-if="orderconfirmation && orderconfirmation.length">
                <v-card class="ma-2" min-width="80%">
                    <v-card-text>
                        <div class="d-flex font-weight-bold">
                            <div class="flex-grow-1">{{$translate('You bought')}}</div>
                        </div>
                        <div v-for="(crow,index) in orderconfirmation" :key="index">
                            {{crow.title}}
                        </div>

                        <template v-if="totalFromServer > 0">
                            <v-divider />
                            <div class="d-flex">
                                <div class="flex-grow-1">{{$translate('Total')}}</div>
                                <div>{{totalFromServer | price}}</div>
                            </div>
                        </template>

                        <div v-if="paidByMethod == 'invoice'">
                            <v-alert type="info">
                                {{$translate('The invoice is sent to the provided email address.')}}
                                <br/>
                                {{$translate('You can also retrieve it later under \"My Pages\">\"Payments\".')}}
                            </v-alert>
                        </div>
                        <div v-else-if="paidByMethod == 'directdebit'">
                            <v-alert type="info">
                                {{$translate('You can view the direct debit invoice under "My pages">"Payments" afterwards.')}}
                            </v-alert>
                        </div>
                        <div v-else>
                            <v-btn v-if="hasReceipt" @click="getReceipt" color="primary" class="zoezi-button-thin" block>
                                <v-icon left>mdi-file-document-outline</v-icon>
                                {{$translate('Get receipt')}}
                            </v-btn>
                        </div>

                    </v-card-text>
                </v-card>
                <v-avatar size=64 color="white" class="elevation-2">
                    <v-icon x-large color="primary">mdi-cart-outline</v-icon>
                </v-avatar>
            </div>
        </v-sheet>
    </v-dialog>
</template>

<script>
import {downloadFile, isExpoApp} from '../util.js'
export default {
    name: 'zoezi-checkout-done-dialog',

    computed: {
        c() {
            return this.$store.state.checkoutDoneDialog;
        },
        orderconfirmation() {
            return this.c.orderconfirmation;
        },
        totalFromServer() {
            return this.c.totalFromServer;
        },
        paidByMethod() {
            return this.c.paidByMethod;
        },
        hasReceipt() {
            return this.orderconfirmation && this.orderconfirmation.length && this.orderconfirmation[0].bundle_id && this.paidByMethod != 'unknown';
        },
        thankYouText() {
            return this.c.thankYouText || this.$translate('Thank you for your purchase!');
        }
    },
    methods: {
        getReceipt() {
            let id = this.orderconfirmation[0].bundle_id;
            if (isExpoApp()) {
                let data = { api: { url: 'current', path: '/api/memberapi/receipt/get', args: { id } }, type: 'pdf'};
                window.ReactNativeWebView.postMessage(JSON.stringify({type: 'openFile', data}));
            } else {
                this.$api.get('/api/memberapi/receipt/get', {id}, {blob: true}).then(x => {
                    downloadFile({filename: this.$translate('Receipt') + '.pdf', data: x, type: 'application/pdf'});
                });
            }
        }
    }
}
</script>
